export const STALE_SERVER_ACTION_ERROR_CODE = 'STALE_SERVER_ACTION'

const STALE_SERVER_ACTION_PATTERNS = ['Failed to find Server Action', 'older or newer deployment'] as const

type ErrorWithOptionalCause = {
  cause?: unknown
  code?: unknown
  digest?: string
  message?: string
}

function isErrorWithOptionalCause(value: unknown): value is ErrorWithOptionalCause {
  return typeof value === 'object' && value !== null
}

function collectErrorMessages(error: unknown): string[] {
  if (typeof error === 'string') {
    return error.trim() ? [error] : []
  }

  if (!isErrorWithOptionalCause(error)) {
    return []
  }

  const messages = typeof error.message === 'string' && error.message.trim() ? [error.message] : []

  return [...messages, ...collectErrorMessages(error.cause)]
}

export function isStaleServerActionError(error: unknown): boolean {
  if (isErrorWithOptionalCause(error) && error.code === STALE_SERVER_ACTION_ERROR_CODE) {
    return true
  }

  return collectErrorMessages(error).some((message) =>
    STALE_SERVER_ACTION_PATTERNS.every((pattern) => message.includes(pattern))
  )
}

export function getStaleServerActionDetails(error: unknown): {
  message: string | null
  actionId?: string
  digest?: string
} {
  const message =
    collectErrorMessages(error).find((candidate) =>
      STALE_SERVER_ACTION_PATTERNS.every((pattern) => candidate.includes(pattern))
    ) ?? null

  if (!message) {
    return { message: null }
  }

  const actionIdMatch = message.match(/Failed to find Server Action "([^"]+)"/)
  const digest = isErrorWithOptionalCause(error) && typeof error.digest === 'string' ? error.digest : undefined

  return {
    actionId: actionIdMatch?.[1],
    digest,
    message,
  }
}
